import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

import { m } from "@/paraglide/messages";

dayjs.extend(relativeTime);
dayjs.extend(utc);

const dateTimeFormats = {
  dots: "DD.MM.YYYY.",
  short: "DD / MM / YY @ HH:mm",
  medium: "DD / MM / YYYY @ HH:mm",
  long: "MMM DD, YYYY @ HH:mm",
  stripe: "YYYY-MM-DD",
  locale: "DD-MM-YYYY",
  file_name: "DD-MMM-YYYY@HH:mm",
} as const;

type DateTimeFormat = keyof typeof dateTimeFormats;

export const formatDate = (
  dateString: string,
  format: DateTimeFormat,
): string => {
  // Parse as UTC and format without converting to local time
  return dayjs.utc(dateString).format(dateTimeFormats[format]);
};

export const formatDateLocal = (
  dateString: string,
  format: DateTimeFormat,
): string => {
  return dayjs.utc(dateString).local().format(dateTimeFormats[format]);
};

export const formatRelativeDate = (dateStr: string | null): string => {
  if (!dateStr) return "-";
  // Parse as UTC and normalize to start of day to calculate days difference without timezone conversion
  const date = dayjs.utc(dateStr).startOf("day");
  const now = dayjs.utc().startOf("day");
  const diffDays = now.diff(date, "day");

  if (diffDays === 0) return m.source_status_today();
  if (diffDays === 1) return m.source_status_yesterday();
  return m.source_status_days_ago({ count: String(diffDays) });
};

export const formatTriggeredAt = (dateStr: string | null): string => {
  if (!dateStr) return "-";
  return dayjs.utc(dateStr).local().format("MMM D, YYYY @ HH:mm");
};
